module.exports = __webpack_public_path__ + "static/img/gift.d19f121.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gift.png
// module id = XcIT
// module chunks = 1